import React from 'react';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import { SCREEN_SIZE } from '@/v2/../lib/theme/breakPoints';
import PackageOptionContent from '../PackageOptionContent';
import Pill, { StyledPill } from '../PackageOptionPill';
import Tick, { StyledTick } from '../PackageOptionTick';

const StyledPackageOption = styled(Flex)`
  width: inherit;
  position: relative;
`;

interface StyledPackageOptionCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  readonly selected: boolean;
}

const StyledPackageOptionCard = styled.div<{ selected: boolean }>`
  position: relative;
  display: flex;
  width: inherit;

  ${StyledPill} {
    z-index: 1;

    top: -12px;
    ${SCREEN_SIZE.MD} {
      top: -20px;
    }

    overflow: ${({ selected }: StyledPackageOptionCardProps) =>
      selected ? 'hidden' : 'unset'};
  }

  ${StyledTick} {
    color: ${themeGet('components.packageOption.selected.borderColor')};
  }

  ${PackageOptionContent} {
    padding: 0 ${themeGet('components.packageOption.padding')};
  }
`;

interface Props {
  children?: React.ReactNode;
  selected?: boolean;
  pillText: string | null;
  testId?: string;
}

const PackageOptionCard = ({ selected, pillText, children }: Props) => (
  <StyledPackageOptionCard
    selected={selected}
    data-testid="PACKAGE_OPTION_CARD"
  >
    {pillText && <Pill message={pillText} icon={'earlyAccess'} />}
    {selected && <Tick />}
    {children && (
      <StyledPackageOption data-testid="PACKAGE_OPTION_CONTENT">
        {children}
      </StyledPackageOption>
    )}
  </StyledPackageOptionCard>
);

export default PackageOptionCard;
